import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImagePreview = styled.div`
  margin-top: 10px;
  img {
    max-width: 150px;
  }
`;
